import type { CloserLead } from '@/types'

export function negotiationLockNotice(lock: NonNullable<CloserLead['exclusividade']>): string {
  if (lock.permanente) {
    return `Cliente de ${lock.comercial}. Fica com esse comercial. Telefone oculto.`
  }
  if (lock.ate) {
    const until = new Date(lock.ate).toLocaleDateString('pt-BR')
    return `Em negociação com ${lock.comercial} até ${until}. Telefone oculto.`
  }
  return `Em negociação com ${lock.comercial}. Telefone oculto.`
}
